import React, { useState, useCallback } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import BootSequence from './components/BootSequence';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Gameplay from './components/Gameplay';
import Races from './components/Races';
import MapWorld from './components/MapWorld';
import Weapons from './components/Weapons';
import TerraformDevice from './components/TerraformDevice';
import Features from './components/Features';
import TeamDossier from './components/TeamDossier';
import FutureExpansion from './components/FutureExpansion';
import AboutContact from './components/AboutContact';
import Footer from './components/Footer';

function App() {
  const seenBoot = typeof window !== 'undefined' && sessionStorage.getItem('hasSeenBoot');
  const [showBoot, setShowBoot] = useState(!seenBoot);
  const [showContent, setShowContent] = useState(!!seenBoot);

  const handleBootComplete = useCallback(() => {
    sessionStorage.setItem('hasSeenBoot', 'true');
    setShowBoot(false);
    setTimeout(() => setShowContent(true), 300);
  }, []);

  return (
    <div className="App">
      {showBoot && <BootSequence onComplete={handleBootComplete} />}

      {showContent && (
        <>
          <Navigation />
          <main data-testid="main-scroll">
            <Hero />
            <Gameplay />
            <div className="shared-sci-fi-background" data-testid="shared-sci-fi-background">
              <Races />
              <MapWorld />
              <Weapons />
              <TerraformDevice />
              <Features />
              <TeamDossier />
              <FutureExpansion />
              <AboutContact />
              <Footer />
            </div>
          </main>
        </>
      )}

      <Toaster />
    </div>
  );
}

export default App;
